import { Bones } from '@simplywallst/ui-core';

export const RecentInsightsSkelecton = () => (
  <>
    <div className="grid py-0">
      <Bones maxWidth="100%" minHeight="210px" />
    </div>
    <div className="grid py-1">
      <Bones maxWidth="100%" minHeight="108px" />
    </div>
    <div className="grid py-0">
      <Bones maxWidth="100%" minHeight="100px" />
    </div>
  </>
);
